import React, { FC } from 'react';

export interface LieferbarCardProps {
  /** Shipping type label (left) */
  label: string;
  /** Pending count (right) */
  count: number;
}

/**
 * Single category row inside the Lieferbar widget (white card, border, label + count).
 */
const LieferbarCard: FC<LieferbarCardProps> = ({ label, count }) => {
  return (
    <div className="lieferbar-widget__cell">
      <span className="lieferbar-widget__cell-label">{label}</span>
      <span className="lieferbar-widget__cell-value">{count}</span>
    </div>
  );
};

export default LieferbarCard;
